'use strict';

import { observable, observe, configure, action, flow, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";
import {isEmpty, isFalse} from "@uw-it-sis/lib-react/lib/Utils";

import {MetricLabels} from "./Constants";

import api from "./Api";
import RegToolsInjector from './RegToolsInjector';

const exceptionUtils = appStore.getExceptionUtils();
const analyticsStore = appStore.getAnalyticsStore();

class RegistrationStore {
    storeName = "RegistrationStore";
    componentKey = this.storeName;

    // Observables
    state = States.initial;
    data = {};

    termId = "";
    labels = {}; // for analytics labels

    constructor() {
        makeObservable(this, {
            state: observable,
            data: observable,
        });
    }

    initialize = (termId, callback) => {
        this.state = States.pending;

        this.termId = termId;
        this.labels = analyticsStore.label(MetricLabels.quarter, this.termId).get();

        this.loadData(callback);
    }

    loadData = flow(function* (callback) {
        analyticsStore.startTimer("Registration-LoadData", this.labels);

        if (appStore.isDevMode()) {
            console.log(`[${this.storeName}] ${TermUtils.makeTermDescriptionFromTermId(this.termId)}: data load started`);
        }

        try {
            if (RegToolsInjector.isPreProdEnvironment()) {
                this.data = yield RegToolsInjector.forgeRegistrationCall(this.termId);
            } else {
                this.data = yield api.getRegistration(this.termId);
            }

            if (appStore.isDevMode()) {
                console.log(`[${this.storeName}] ${TermUtils.makeTermDescriptionFromTermId(this.termId)}: data load completed`);
            }

            this.state = States.done;

            if (callback && typeof callback === "function") {
                callback();
            }
        } catch (error) {
            this.state = States.error;
        } finally {
            analyticsStore.endTimer("Registration-LoadData");
        }

    }.bind(this));

    refresh = () => {
        this.state = States.pending;
        this.loadData();
    }

    getData = () => {
        return this.data;
    }

    hasData = () => {
        return isFalse(isFalse(this.data));
    }

}

export default new RegistrationStore();